import { CheckboxField, EntityDrawerProps, FormDrawer, FormDrawerContent, TextField } from "@dgs/core";
import { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Address } from "../../contactUpdateInquiries/Address";
import { ContactCompanyFormState } from "../../shared/types/contactCompany";

const AddressWrapper = styled.div`
	display: grid;
	grid-template-rows: max-content 1fr;
	gap: ${({ theme }) => theme.spacing(2)};
`;

export const ContactCompanyDrawer: FC<EntityDrawerProps<ContactCompanyFormState>> = ({ initialValues, ...props }) => {
	const { t } = useTranslation();

	const validate = useCallback(
		(values: ContactCompanyFormState) => {
			const errors: { [K in keyof ContactCompanyFormState]?: any } = {};

			if (!values.name) {
				errors.name = t("Required field");
			}

			return errors;
		},
		[t],
	);

	return (
		<FormDrawer
			{...props}
			initialValues={initialValues}
			validate={validate}
			renderForm={(props) => (
				<FormDrawerContent {...props}>
					<TextField name="name" label={t("Name")} disabled={true} />
					<TextField name="position" label={t("Position")} />
					<CheckboxField label={t("Mark as primary")} name="isPrimary" />
					{initialValues.primaryAddress && (
						<AddressWrapper>
							<b>{t("Primary company address")}</b>
							<Address address={initialValues.primaryAddress} />
						</AddressWrapper>
					)}
				</FormDrawerContent>
			)}
		/>
	);
};
